/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Tick from "../../icons/tick.svg?react";
import SubmitButton from "../Button";
import ConfirmBox from "../ConfirmBox";
import AICompanion from "./AICompanion";
import Create from "../../icons/CreateAuditsvg.svg?react";
import Breadcrumb from "../Breadcrumb";
import "./style.scss";
interface Step {
  number: number;
  title: string;
  icon: React.ElementType; // works for React components like `Users`
}
interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface Props {
  renderStepContent: any;
  aiContextHistory: any;
  auditUpdatedata?: any;
  steps: Step[];
  prevStep: any;
  currentStep: any;
  aiSuggestion?: any;
  loading: any;
  handleSubmit: any;
  nextStep: any;
  nextDisable: any;
  userData: any;
  submitClicked: boolean;
  showConfirm: boolean;
  setShowConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  Heading: string;
  showToast: boolean;
  showAISuggestion: boolean;
  showAItooltip: boolean;
  AIloading?: boolean;
  showAICompanion: boolean;
  setShowAISuggestion: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAIobservation: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAItooltip: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAICompanion?: React.Dispatch<React.SetStateAction<boolean>>;
  breadcrumbItems: BreadcrumbItem[];
}

const CreateAudit: React.FC<Props> = ({
  renderStepContent,
  steps,
  prevStep,
  currentStep,
  loading,
  handleSubmit,
  nextStep,
  nextDisable,
  submitClicked,
  showConfirm,
  setShowConfirm,
  Heading,
  showToast,
  aiContextHistory,
  setShowAISuggestion,
  setShowAIobservation,
  showAISuggestion,
  aiSuggestion,
  showAItooltip,
  setShowAItooltip,
  userData,
  AIloading,
  showAICompanion,
  setShowAICompanion,
  auditUpdatedata,
  breadcrumbItems,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (currentStep === 5) {
      setShowAICompanion?.(false);
    }
  }, [currentStep]);
  return (
    <div className="audit-registration">
      <div className="page-header">
        <Breadcrumb items={breadcrumbItems} />
        <div className="steps-sidebar">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isActive = currentStep === step.number;
            const isCompleted = currentStep > step.number;
            const state = isActive || isCompleted ? "" : "disabled";

            return (
              <div key={step.number} className={`step-item ${state}`}>
                <div className="step-wrapper">
                  <div
                    className={`step-circle ${isCompleted ? "completed" : isActive ? "active" : ""
                      }`}
                  >
                    <Icon className="step-icon" />
                  </div>
                  <div className="step-info">
                    <div className="step-number" data-testid="step-item">
                      Step {step.number} {isCompleted && <Tick />}
                    </div>
                    <div className="step-title">{step.title}</div>
                  </div>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`step-connector ${isCompleted ? "completed" : ""
                      }`}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="layout-container">
        <div className="content-section">
          <div className="main-content" data-testid="step-content">
            {renderStepContent()}
          </div>
        </div>

        <div
          className={`right-panel ${showAICompanion ? "open" : "closed"}`}
          data-testid="ai-panel"
        >
          <AICompanion
            onClose={() => setShowAICompanion?.(false)}
            aiSuggestion={aiSuggestion}
            loading={AIloading}
            aiContextHistory={aiContextHistory}
            userData={userData}
          />
        </div>
      </div>

      <ConfirmBox
        message="Are you sure you want to cancel?"
        handleClose={() => setShowConfirm(false)}
        show={showConfirm}
        onConfirm={() => navigate("/audit-scheduled")}
      />

      <div className="navigation">
        <SubmitButton
          data-testid="prev-button"
          onClick={prevStep}
          disabled={currentStep === 1}
          className="nav-button secondary"
          type="primary"
        >
          <ChevronLeft className="icon-sm" />
          Previous
        </SubmitButton>
        <div className="nav-actions">
          {currentStep < 5 ? (
            <SubmitButton
              data-testid="next-button"
              className="nav-button nextButton"
              onClick={nextStep}
              type="primary"
              disabled={nextDisable}
            >
              Next
              <ChevronRight className="icon-sm" style={{ color: "#fff" }} />
            </SubmitButton>
          ) : (
            <SubmitButton
              data-testid="submit-button "
              onClick={handleSubmit}
              disabled={showToast || loading}
              className="nav-button auditSubmitbtn"
              type="primary"
            >
              {loading
                ? "Submitting"
                : submitClicked && showToast
                  ? "Submitted"
                  : "Submit"}{" "}
              {submitClicked && showToast && <Tick data-testid="tick-icon" />}
              {loading && (
                <Spinner
                  animation="border"
                  variant="light"
                  className="submitLoader"
                />
              )}
            </SubmitButton>
          )}
        </div>
      </div>
    </div>
  );
};
export default CreateAudit;
